module.exports = __webpack_public_path__ + "static/media/ios-at.f5b9c225.svg";